export const readFileAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    if (!file){
      reject(new Error('No file provided'));
      return;
    } 

    const reader = new FileReader();
    reader.onload = () => {
      if (!reader.result) {
        reject(new Error('Failed to read file'));
        return;
      } 
      const base64 = reader.result.includes(',') 
        ? reader.result.split(',')[1] 
        : reader.result;
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
